import enUi from './en/support/ui.json';
import enFaq from './en/support/faq.json';
import enGuideUi from './en/support/guides/_ui.json';
import endashboard from './en/support/guides/dashboard.json';
import enorders from './en/support/guides/orders.json';
import eninvoiceOrders from './en/support/guides/invoiceOrders.json';
import enrevenue from './en/support/guides/revenue.json';
import encostPercent from './en/support/guides/costPercent.json';
import enpriceAlerts from './en/support/guides/priceAlerts.json';
import encostPrice from './en/support/guides/costPrice.json';
import enutilization from './en/support/guides/utilization.json';
import enmenus from './en/support/guides/menus.json';
import encharts from './en/support/guides/charts.json';
import enrecipes from './en/support/guides/recipes.json';
import enchecklists from './en/support/guides/checklists.json';
import enmep from './en/support/guides/mep.json';
import eninventory from './en/support/guides/inventory.json';
import enleakage from './en/support/guides/leakage.json';
import ennotifications from './en/support/guides/notifications.json';
import enwaste from './en/support/guides/waste.json';
import enstaff from './en/support/guides/staff.json';
import enprofile from './en/support/guides/profile.json';
import enuserProfile from './en/support/guides/userProfile.json';
import ensettings from './en/support/guides/settings.json';
import ensubscription from './en/support/guides/subscription.json';
import ensupport from './en/support/guides/support.json';
import enhome from './en/support/guides/home.json';
import eninvoices from './en/support/guides/invoices.json';
import nlUi from './nl/support/ui.json';
import nlFaq from './nl/support/faq.json';
import nlGuideUi from './nl/support/guides/_ui.json';
import nldashboard from './nl/support/guides/dashboard.json';
import nlorders from './nl/support/guides/orders.json';
import nlinvoiceOrders from './nl/support/guides/invoiceOrders.json';
import nlrevenue from './nl/support/guides/revenue.json';
import nlcostPercent from './nl/support/guides/costPercent.json';
import nlpriceAlerts from './nl/support/guides/priceAlerts.json';
import nlcostPrice from './nl/support/guides/costPrice.json';
import nlutilization from './nl/support/guides/utilization.json';
import nlmenus from './nl/support/guides/menus.json';
import nlcharts from './nl/support/guides/charts.json';
import nlrecipes from './nl/support/guides/recipes.json';
import nlchecklists from './nl/support/guides/checklists.json';
import nlmep from './nl/support/guides/mep.json';
import nlinventory from './nl/support/guides/inventory.json';
import nlleakage from './nl/support/guides/leakage.json';
import nlnotifications from './nl/support/guides/notifications.json';
import nlwaste from './nl/support/guides/waste.json';
import nlstaff from './nl/support/guides/staff.json';
import nlprofile from './nl/support/guides/profile.json';
import nluserProfile from './nl/support/guides/userProfile.json';
import nlsettings from './nl/support/guides/settings.json';
import nlsubscription from './nl/support/guides/subscription.json';
import nlsupport from './nl/support/guides/support.json';
import nlhome from './nl/support/guides/home.json';
import nlinvoices from './nl/support/guides/invoices.json';

export const supportResources = {
  en: { support: enUi, supportFaq: enFaq, supportGuides: { _ui: enGuideUi, dashboard: endashboard, orders: enorders, invoiceOrders: eninvoiceOrders, revenue: enrevenue, costPercent: encostPercent, priceAlerts: enpriceAlerts, costPrice: encostPrice, utilization: enutilization, menus: enmenus, charts: encharts, recipes: enrecipes, checklists: enchecklists, mep: enmep, inventory: eninventory, leakage: enleakage, notifications: ennotifications, waste: enwaste, staff: enstaff, profile: enprofile, userProfile: enuserProfile, settings: ensettings, subscription: ensubscription, support: ensupport, home: enhome, invoices: eninvoices } },
  nl: { support: nlUi, supportFaq: nlFaq, supportGuides: { _ui: nlGuideUi, dashboard: nldashboard, orders: nlorders, invoiceOrders: nlinvoiceOrders, revenue: nlrevenue, costPercent: nlcostPercent, priceAlerts: nlpriceAlerts, costPrice: nlcostPrice, utilization: nlutilization, menus: nlmenus, charts: nlcharts, recipes: nlrecipes, checklists: nlchecklists, mep: nlmep, inventory: nlinventory, leakage: nlleakage, notifications: nlnotifications, waste: nlwaste, staff: nlstaff, profile: nlprofile, userProfile: nluserProfile, settings: nlsettings, subscription: nlsubscription, support: nlsupport, home: nlhome, invoices: nlinvoices } },
};
